export default __webpack_public_path__ + "static/media/n.5ba7d133.svg";